<template>
    <div class="row" style="margin-bottom: 0rem">
        <div :class="getMenuClass(menuEntry)" v-for="(menuEntry, key) in menu" v-bind:key="key" @click="menuClick(menuEntry)">
            {{ menuEntry.name }}
        </div>
    </div>
</template>

<script>
  import { Can } from '../../../permission/ability.js';
  
  export default {
    data() {
      return {
        id: ''
      };
    },
    methods: {
      Can,
      getMenuClass(entry) {
        return entry.id === this.entry.id ? ' category-widget active' : ' category-widget'
      },
      menuClick(entry) {
        this.$emit('entryClick', entry);
      },
    },
    props: ['menu', 'entry']
  };
</script>

<style lang="scss">
    @import "./scss/notifications.scss";
</style>